// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1B5iF","balanceDisclaimer":"posDashboard_balanceDisclaimer__7zWMc"};